import styled, { css } from 'styled-components/macro';

import { IconStyles } from 'components/Icon';

import media from 'helpers/media';

const LogoStyled = styled.a`
    & .main {
        display: block;
    }
    & .icon {
        display: none;
    }
    ${media.toTablet`
        & .icon {
            display: block;
        }

        & .main {
            display: none;
        }
    `}
`;

const MainCTA = styled.div`
    margin-left: ${({ theme }) => theme.space.large};
    padding-left: ${({ theme }) => theme.space.large};
    border-left: 1px solid rgba(255, 255, 255, 0.5);

    ${({ theme }) => media.toTablet`
        margin-left: ${theme.space.base};
        padding-left: ${theme.space.base};
    `}
`;

const SlotLeft = styled.div`
    transition: opacity 150ms ease-in;
    height: 100%;
    display: flex;
    align-items: center;
`;

const SlotRight = styled.div`
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
    margin-left: auto;
`;

const NavSecondary = styled.div``;

const NavCTA = styled.div`
    margin-top: auto;
    margin-bottom: auto;
    padding: 0 24px;
`;

const NavMenu = styled.nav`
    height: 100%;
    display: flex;

    ${() => `
        & > div:not(${NavCTA}) {
            display: flex;
        }
    `}

    ${({ theme }) => media.toTablet`
        .Nlock_sc & {
            transform: translate(0, 0);
        }

        .Nlock_sc & > * {
            opacity: 1;
            transform: translate(0, 0);
        }

        position: fixed;
        display: block;
        top: 48px;
        left: 0;
        width: 100%;

        height: calc(100vh - 48px);
        background-color: ${theme.colors.darkGrey};
        transform: translate(100%, 0);
        transition: all 150ms ease-in;
        
        padding-top: ${theme.space.medium};
        
        box-sizing: border-box;
        overflow: auto;
        -webkit-overflow-scrolling: touch;

        & > * {
            opacity: 0;
            transform: translate(60px, 0);
            transition: all 250ms linear 50ms;
        }

        & > div:not(${NavCTA}) {
            flex-direction: column;
        }

        ${NavCTA},
        ${NavSecondary} {
            border-top: 1px solid rgba(255, 255, 255, 0.4);
            margin-top: ${theme.space.large};
            padding: ${theme.space.large} ${theme.space.base} 0;
        }
        
        ${NavCTA}:not(:first-child),
         ${NavSecondary}:not(:first-child) {
            margin-top: ${theme.space.medium};
        }
    `}
`;

const Navigation = styled.div`
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    width: 100%;
    height: 65px;
    background-color: ${({ theme }) => theme.colors.darkGrey};
    display: flex;
    align-items: center;

    box-sizing: border-box;
    padding: 0 ${({ theme }) => theme.space.xlarge};

    ${({ theme }) => media.toTablet`
        padding: 0 ${theme.space.medium};
    `};

    ${({ theme }) => media.toTablet`
        height: 48px;

        .Nlock_sc & {
            background-color: ${theme.colors.darkGrey};
        }

        ${NavSecondary} {
            padding-top: ${theme.space.medium};
            padding-left: 0;
            padding-right: 0;
            padding-bottom: ${theme.space.giant};
            margin-bottom: ${theme.space.giant};
        }
    `}
`;

const ButtonIconStyles = css`
    cursor: pointer;
    position: relative;
    display: none;
    padding: 0;
    height: 100%;
    align-items: center;
    justify-content: center;
    color: #fff;

    &:before,
    &:after {
        ${IconStyles}
        position: absolute;
        transition: all 150ms linear;
    }

    &:before {
        font-size: 26px;
        width: 26px;
        top: calc(50% - 13px);
        left: calc(50% - 13px);
    }

    &:after {
        font-size: 20px;
        width: 20px;
        top: calc(50% - 10px);
        left: calc(50% - 10px);
        opacity: 0;
        transform: scale(0);
    }
`;

const NavMoreButton = styled.div.attrs({ role: 'button' })`
    ${ButtonIconStyles}

    &:before {
        content: 'menu';
    }

    &:after {
        content: 'close';
    }

    @media screen and (max-width: 1048px) {
        display: flex;
        width: 48px;

        .Nlock_sc &:before {
            opacity: 0;
            transform: scale(0);
        }

        .Nlock_sc &:after {
            opacity: 1;
            transform: scale(1);
        }
    }
`;

const NavProfile = styled.img`
    display: block;
    width: 36px;
    height: 36px;
    border-radius: 100%;
    margin-right: ${({ theme }) => theme.space.small};
`;

const Wrapper = styled.div`
    height: 65px;
    ${media.toTablet`
        height: 48px;
    `}
`;

export {
    NavProfile,
    NavMoreButton,
    NavMenu,
    LogoStyled,
    MainCTA,
    SlotLeft,
    SlotRight,
    Navigation,
    NavSecondary,
    NavCTA,
    Wrapper,
};
